import Vue from 'vue'
import Marketingitem from './Marketingitem.vue'

new Vue({
  el: '#app',data: {
    currentNav: 'Home',
  },
  render: h => h(Marketingitem),
})



// WEBPACK FOOTER //
// ./scripts/marketingitem.js